// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"8d85aa5d","152":"e4c95425","313":"96ea1094","322":"697e73cb"}[chunkId] + ".chunk.js";
};